import {useColorMode} from 'native-base'

export default useColorMode